import getTotalVideos from './videosCountAPI';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
    totalVideos: 0,
    isLoading: false,
    isError: false,
    error: ''
};

export const fetchTotalVideos = createAsyncThunk(
    'videosCount/fetchTotalVideos',
    async ({ tags, search, author }) => {
        const totalVideosCount = await getTotalVideos(tags, search, author);
        console.log(getTotalVideos);
        return totalVideosCount;
    }
);

const videosCountSlice = createSlice({
    name: 'videosCount',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchTotalVideos.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchTotalVideos.fulfilled, (state, action) => {
                state.isLoading = false;
                state.totalVideos = action.payload;
            })
            .addCase(fetchTotalVideos.rejected, (state, action) => {
                state.isLoading = false;
                state.totalVideos = 0;
                state.isError = true;
                state.error = action.error?.message;
            });
    }
});

export default videosCountSlice.reducer;
